import PrimaryButton from "Components/PrimaryButton";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const Tutorial = ({ tutorialPage, setTutorialPage }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!localStorage.getItem("zarastanie_tutorial_completed")) {
      setTutorialPage(1);
    }
  }, [setTutorialPage]);

  const location = useLocation();
  const [isHidden, setIsHidden] = useState(true);

  useEffect(() => {
    if (location.pathname === "/scene") {
      setIsHidden(false);
      return;
    }

    setIsHidden(true);
  }, [location, setIsHidden]);

  useEffect(() => {
    if (
      tutorialPage === 0 &&
      !localStorage.getItem("zarastanie_tutorial_completed")
    ) {
      localStorage.setItem("zarastanie_tutorial_completed", true);
    }
  }, [tutorialPage]);

  return (
    <Fragment>
      {!isHidden && (
        <Fragment>
          {tutorialPage === 1 && (
            <div id="tutorial-step-1" className="tutorial-box">
              <span className="mx-3">{t("TutorialStep1")}</span>
              <PrimaryButton
                className="info"
                text={t("TutorialNextButton")}
                isArrow={false}
                onClick={() => {
                  setTutorialPage(tutorialPage + 1);
                }}
              />
            </div>
          )}
          {tutorialPage === 2 && (
            <div id="tutorial-step-2" className="tutorial-box">
              <span className="mx-3">{t("TutorialStep2")}</span>
              <PrimaryButton
                className="info"
                text={t("TutorialNextButton")}
                isArrow={false}
                onClick={() => {
                  setTutorialPage(tutorialPage + 1);
                }}
              />
            </div>
          )}
          {tutorialPage === 3 && (
            <div id="tutorial-step-3" className="tutorial-box">
              <span className="mx-3">{t("TutorialStep3")}</span>
              <PrimaryButton
                className="info"
                text={t("TutorialNextButton")}
                isArrow={false}
                onClick={() => {
                  setTutorialPage(tutorialPage + 1);
                }}
              />
            </div>
          )}
          {tutorialPage === 4 && (
            <div id="tutorial-step-4" className="tutorial-box">
              <span className="mx-3">{t("TutorialStep4")}</span>
              <PrimaryButton
                className="info"
                text={t("TutorialNextButton")}
                isArrow={false}
                onClick={() => {
                  setTutorialPage(tutorialPage + 1);
                }}
              />
            </div>
          )}
          {tutorialPage === 5 && (
            <div id="tutorial-step-5" className="tutorial-box">
              <span className="mx-3">{t("TutorialStep5")}</span>
              <PrimaryButton
                className="info"
                text={t("TutorialNextButton")}
                isArrow={false}
                onClick={() => {
                  setTutorialPage(0);
                }}
              />
            </div>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default Tutorial;
